import { Navigate, Route, Routes } from 'react-router-dom';

// Pages
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import UnauthorizedPage from '@/pages/errors/UnauthorizedPage';
import ForbiddenPage from '@/pages/errors/ForbiddenPage';
import NotFoundPage from '@/pages/errors/NotFoundPage';
import DashboardPage from '@/pages/DashboardPage';
import ProblemsPage from '@/pages/ProblemsPage';
import ProblemDetailPage from '@/pages/ProblemDetailPage';
import SubmissionsPage from '@/pages/SubmissionsPage';
import SubmissionDetailPage from '@/pages/SubmissionDetailPage';
import LearningPage from '@/pages/LearningPage';
import ProfilePage from '@/pages/ProfilePage';
import AdminProblemsPage from '@/pages/admin/AdminProblemsPage';
import AdminJudgeAgentsPage from '@/pages/admin/AdminJudgeAgentsPage';
import AdminTemplatesPage from '@/pages/admin/AdminTemplatesPage';
import AdminTemplateEditorPage from '@/pages/admin/AdminTemplateEditorPage';
import TemplateGalleryPage from '@/pages/TemplateGalleryPage';
import TemplateRunPage from '@/pages/TemplateRunPage';
import CustomTemplatesPage from '@/pages/CustomTemplatesPage';
import GenerationJobsPage from '@/pages/GenerationJobsPage';
import GenerationJobResultPage from '@/pages/GenerationJobResultPage';
import LlmProvidersPage from '@/pages/LlmProvidersPage';
import AdminGenerationFeedbackPage from '@/pages/admin/AdminGenerationFeedbackPage';
import SettingsPage from '@/pages/settings/SettingsPage';
import ProfileSettingsPage from '@/pages/settings/ProfileSettingsPage';

// Layouts
import MainLayout from '@/components/layouts/MainLayout';
import AuthLayout from '@/components/layouts/AuthLayout';

// Protected Route
import ProtectedRoute from '@/components/common/ProtectedRoute';
import AdminRoute from '@/components/common/AdminRoute';

function App() {
  return (
    <Routes>
      {/* Public landing page — no layout wrapper */}
      <Route path="/" element={<HomePage />} />

      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/401" element={<UnauthorizedPage />} />
        <Route path="/403" element={<ForbiddenPage />} />
        <Route path="/404" element={<NotFoundPage />} />
      </Route>

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/problems" element={<ProblemsPage />} />
        <Route path="/problems/:id" element={<ProblemDetailPage />} />
        <Route path="/submissions" element={<SubmissionsPage />} />
        <Route path="/submissions/:id" element={<SubmissionDetailPage />} />
        <Route path="/learning" element={<LearningPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />}>
          <Route index element={<Navigate to="/settings/profile" replace />} />
          <Route path="profile" element={<ProfileSettingsPage />} />
          <Route path="llm-providers" element={<LlmProvidersPage embedded />} />
        </Route>
        <Route path="/templates" element={<TemplateGalleryPage />} />
        <Route path="/templates/custom" element={<CustomTemplatesPage />} />
        <Route path="/templates/:id/run" element={<TemplateRunPage />} />
        <Route path="/generation-jobs" element={<GenerationJobsPage />} />
        <Route path="/generation-jobs/:id" element={<GenerationJobResultPage />} />
        <Route
          path="/admin/problems"
          element={
            <AdminRoute>
              <AdminProblemsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/judge-agents"
          element={
            <AdminRoute>
              <AdminJudgeAgentsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/templates"
          element={
            <AdminRoute>
              <AdminTemplatesPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/templates/new"
          element={
            <AdminRoute>
              <AdminTemplateEditorPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/templates/:id"
          element={
            <AdminRoute>
              <AdminTemplateEditorPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/generation-feedback"
          element={
            <AdminRoute>
              <AdminGenerationFeedbackPage />
            </AdminRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}

export default App;
